// Functions
import './helpers/index';
import './functions/ada';
import './functions/smoothScroll';
import './functions/urlParams';
import './functions/popovers';
import './functions/accessibleHeader';

// Animations
import './animations/logo';
import './animations/rotatingBadge';
import './animations/cardCtas';
import './animations/postCard';

// Components
import './components/header';
import './components/popups';
import './components/accordions';
import './components/newsfeedFilters';
import './components/mobileReadMore';

// Modules
import './modules/cardSlider';
import './modules/cardCtas';
import './modules/newsfeedGrid';
import './modules/venuesGrid';
import './modules/testimonials';

// Import main scss file here. This will compile to a css file in the dist folder
import '../sass/style.scss';
